module.exports = __webpack_public_path__ + "static/media/arrow_up.f38c7829.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/arrow_up.svg
// module id = 485
// module chunks = 0